export default { sha: 'a221d93f91ddeb05efebd7fb431322ff320c4edc', buildNumber: 'undefined' }
